import React, { useState } from "react";
import { Link } from "react-router-dom";

export const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <header className="w-full bg-white/90 backdrop-blur-md shadow-sm sticky top-0 z-50">
      <div className="px-6 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="font-display text-xl font-semibold text-brand-primary hover:opacity-80"
          onClick={() => setMenuOpen(false)}
        >
          Aishwarya Rao
        </Link>

        {/* Desktop nav */}
        <nav className="hidden sm:flex gap-6 font-medium text-gray-700">
          <Link to="/" className="hover:text-brand-primary transition-colors">Home</Link>
          <Link to="/#work" className="hover:text-brand-primary transition-colors">Work</Link>
          <Link to="/#about" className="hover:text-brand-primary transition-colors">About</Link>
          <Link to="/blog" className="hover:text-brand-primary transition-colors">Blog</Link>
          <Link to="/#contact" className="hover:text-brand-primary transition-colors">Contact</Link>
        </nav>

        {/* Resume button always visible */}
        <div className="hidden sm:block">
          <a
            href="/resume.pdf"
            className="rounded-md bg-brand-primary text-white px-4 py-2 text-sm font-medium hover:bg-brand-secondary transition-colors"
            download
          >
            Download Résumé
          </a>
        </div>

        {/* Hamburger */}
        <button
          className="sm:hidden focus:outline-none text-brand-primary"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-7 h-7"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <nav className="sm:hidden px-6 pb-4 flex flex-col gap-4 font-medium text-gray-700">
          <Link to="/" className="hover:text-brand-primary" onClick={() => setMenuOpen(false)}>Home</Link>
          <Link to="/#work" className="hover:text-brand-primary" onClick={() => setMenuOpen(false)}>Work</Link>
          <Link to="/#about" className="hover:text-brand-primary" onClick={() => setMenuOpen(false)}>About</Link>
          <Link to="/blog" className="hover:text-brand-primary" onClick={() => setMenuOpen(false)}>Blog</Link>
          <Link to="/#contact" className="hover:text-brand-primary" onClick={() => setMenuOpen(false)}>Contact</Link>
          <a
            href="/resume.pdf"
            className="rounded-md bg-brand-primary text-white px-4 py-2 text-sm font-medium hover:bg-brand-secondary transition-colors w-max"
            download
            onClick={() => setMenuOpen(false)}
          >
            Download Résumé
          </a>
        </nav>
      )}
    </header>
  );
};
